import { mapState } from 'vuex';
import { isNullOrEmpty } from '@/utils/vuex';
export default {
  name: 'CoreTenantScopeAccessSelector',
  props: {
    subject: {
      type: String,
      required: false,
      default: 'UserManagement'
    },
    action: {
      type: String,
      required: false,
      default: 'manage'
    },
    userId: {
      type: String,
      required: false,
      default: ''
    },
    roles: {
      type: Array,
      required: false,
      default: () => []
    },
    allowEmptyRoleSet: {
      type: Boolean,
      required: false,
      default: () => false
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      stepperIndex: 1,
      selectedScope: {},
      chosenRoles: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {
    roles() {
      this.chosenRoles = this.roles;
    }
  },
  methods: {
    isNullOrEmpty,
    didSelectScope(scope) {
      this.selectedScope = scope;
      this.stepperIndex = 2;
      this.$emit('scopeChosen', this.selectedScope.id);
    },
    rolesChosen(roles) {
      this.chosenRoles = roles;
    },
    emitRoles() {
      // NOTE: the tenantId is delivered from the scope-tree request just as `tenant`!
      this.$emit('scopeRolesChosen', this.chosenRoles, this.selectedScope.id, this.selectedScope.tenant);
      this.resetForm();
    },
    resetForm() {
      this.stepperIndex = 1;
      this.selectedScope = {};
    }
  }
};